module.exports = {
  chinese: 'zh',
  default: 'en',
};
